import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex')({
  beforeLoad: () => getTitleContextSlice('Rule Set'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
